var _g, _g2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCybersecurity(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 512 512",
    xmlSpace: "preserve",
    width: "150px",
    height: "150px",
    fill: "#000000",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E50914"
    },
    d: "M256,0C201.824,56.96,122.944,65.816,79.104,65.816c-19.8,0-32.432-1.808-32.432-1.808s0,92,0,224 S256,512,256,512s209.328-92,209.328-224s0-224,0-224s-12.632,1.808-32.432,1.808C389.056,65.816,310.208,56.96,256,0L256,0z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M256.608,210.256c-67.152,0-93.912-55.8-95.016-58.168l10.872-5.08 c0.984,2.096,24.8,51.248,84.144,51.248c59.552,0,83.24-50.144,83.48-50.648l10.904,5 C349.912,154.952,323.776,210.256,256.608,210.256z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M256.76,386.536c-75.472,0-136.864-61.4-136.864-136.856s61.4-136.856,136.864-136.856 s136.856,61.4,136.856,136.856S332.224,386.536,256.76,386.536z M256.76,124.816c-68.848,0-124.864,56.008-124.864,124.856 s56.016,124.856,124.864,124.856s124.856-56.008,124.856-124.856S325.616,124.816,256.76,124.816z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 250.76,
    y: 117.824,
    style: {
      fill: "#FFFFFF"
    },
    width: 12,
    height: 256.96
  }), /*#__PURE__*/React.createElement("rect", {
    x: 128.56,
    y: 243.672,
    style: {
      fill: "#FFFFFF"
    },
    width: 258.936,
    height: 12
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M172.464,344.336l-10.872-5.08c1.104-2.376,27.864-58.168,95.016-58.168 c67.168,0,93.304,55.296,94.384,57.648l-10.896,5.016c-0.96-2.072-24.168-50.664-83.488-50.664 C197.264,293.096,173.448,342.248,172.464,344.336z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M249.944,383.024c-2.544-2.328-62.2-57.8-62.2-133.352c0-75.664,61.016-129.08,63.616-131.312 l7.832,9.096c-0.6,0.504-59.456,52.16-59.456,122.216c0,70.176,57.72,123.96,58.304,124.496L249.944,383.024z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M263.584,383.024l-8.104-8.848c0.584-0.536,58.304-54.32,58.304-124.496 c0-70.064-58.848-121.712-59.456-122.216l7.832-9.096c2.6,2.232,63.616,55.648,63.616,131.312 C325.784,325.232,266.128,380.696,263.584,383.024z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCybersecurity);
export default __webpack_public_path__ + "static/media/cybersecurity.814a08911e0b463edb4a3af169491d78.svg";
export { ForwardRef as ReactComponent };